<template>
  <div style="padding: 10% 0%">
    <h3 class="donation-title">Bedankt voor uw donatie</h3>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  created() {
    this.$store.state.page.index = 4
  },
  data: () => {
    return {}
  },
  methods: {},
}
</script>
